
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[shopId]/[productId]/[slug]",
      function () {
        return require("private-next-pages/product/[shopId]/[productId]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[shopId]/[productId]/[slug]"])
      });
    }
  